import React from 'react';
import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  MinusOutlined,
} from '@ant-design/icons';
import { Tag } from 'antd';

export type PeriodChange = {
  key: string;
  label: string;
  unit: '%' | 'bp';
  value?: number;
};

const PeriodChangeTag: React.FC<{ change: PeriodChange }> = ({ change }) => {
  const direction =
    change.value === undefined
      ? 'missing'
      : change.value > 0
        ? 'up'
        : change.value < 0
          ? 'down'
          : 'flat';
  const color =
    direction === 'up' ? 'green' : direction === 'down' ? 'red' : undefined;
  const formattedValue =
    change.value === undefined
      ? '—'
      : `${change.value > 0 ? '+' : ''}${change.value.toFixed(
          change.unit === '%' ? 2 : 1,
        )}${change.unit}`;

  return (
    <Tag
      bordered={false}
      className="assessment-inspect-assessment__period-change-tag"
      color={color}
    >
      {direction === 'up' ? (
        <ArrowUpOutlined />
      ) : direction === 'down' ? (
        <ArrowDownOutlined />
      ) : direction === 'flat' ? (
        <MinusOutlined />
      ) : null}{' '}
      {change.label} {formattedValue}
    </Tag>
  );
};

export default PeriodChangeTag;
